const FirstUpper = (text: string) => {
  let newText = text
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
  newText = newText
    .split('-')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('-');
  return newText;
};
export default {
  FirstUpper,
};
